/* eslint-disable camelcase */
module.exports = function getResource(label, vars = []) {
    const resources = {
        selectAllThatApply: 'Sélectionner toutes les options qui s’appliquent',
        clear: 'Incolore',
        apply: 'Appliquer',
        noResults: 'Aucun résultat.',
        notSure: 'Je ne sais pas',
        noPreference: 'Aucune préférence',
        // ingredients
        aha_glycolic_acid: 'AHA/acide glycolique',
        alcoholFree: 'Sans alcool',
        antioxidants: 'Antioxydants',
        benzoyl_peroxide: 'Peroxyde de benzoyle',
        cbd: 'CBD',
        cleanAtSephora: 'Pur et sain Sephora',
        cleanPlanetPositive: 'Pur et sain + écoresponsable',
        crueltyFree: 'Non testé sur les animaux',
        fragrance_free: 'Sans parfum',
        hyaluronic_acid: 'Acide hyaluronique',
        hydroquinone: 'Hydroquinone',
        mineral: 'Minéral',
        mineralPhysical: 'Minéral physique',
        naturallyDerived: 'D’origine naturelle',
        niacinamide: 'Niacinamide',
        oil_free: 'Sans huile',
        organic: 'Biologique',
        paraben_free: 'Sans parabène',
        peptides: 'Peptides',
        retinoid: 'Rétinoïde',
        salicylicAcid: 'Acide salicylique',
        siliconeFree: 'Sans silicone',
        squalane: 'Squalane',
        sulfate_free: 'Sans sulfate',
        sulfur: 'Soufre',
        vegan: 'Végane',
        vitamin_c: 'Vitamine C',
        // brands
        yvesSaintLaurent: 'Yves Saint Laurent',
        sephoraCollection: 'SEPHORA COLLECTION',
        marcJacobsBeauty: 'Marc Jacobs Beauty',
        charlotteTilbury: 'Charlotte Tilbury',
        givenchy: 'Givenchy',
        tomFord: 'TOM FORD',
        kvdBeauty: 'KVD Beauty',
        dior: 'Dior',
        nars: 'NARS',
        hudaBeauty: 'HUDA BEAUTY',
        hourglass: 'Hourglass',
        armaniBeauty: 'Armani Beauty',
        patMcgrathLabs: 'PAT McGRATH LABS',
        gucci: 'Gucci',
        bobbiBrown: 'Bobbi Brown',
        clinique: 'CLINIQUE',
        tarte: 'tarte',
        nudeStix: 'NUDESTIX',
        lancome: 'Lancôme',
        guerlain: 'GUERLAIN',
        fentyBeautyByRihanna: 'Fenty Beauty by Rihanna',
        urbanDecay: 'Urban Decay',
        makeUpForEver: 'MAKE UP FOR EVER',
        ciateLondon: 'Ciaté London',
        anastasiaBeverlyHills: 'Anastasia Beverly Hills',
        tooFaced: 'Too Faced',
        smashbox: 'Smashbox',
        biteBeauty: 'Bite Beauty',
        valentino: 'Valentino',
        shiseido: 'Shiseido',
        rmsBeauty: 'rms beauty',
        natashaDenona: 'Natasha Denona',
        milkMakeup: 'MILK MAKEUP',
        lauraMercier: 'Laura Mercier',
        kaja: 'Kaja',
        jouerCosmetics: 'Jouer Cosmetics',
        ilia: 'ILIA',
        christianLouboutin: 'Christian Louboutin',
        wanderBeauty: 'Wander Beauty',
        sephoraFavorites: 'Sephora Favorites',
        patrickTa: 'PATRICK TA',
        meltCosmetics: 'Melt Cosmetics',
        makeupByMario: 'MAKEUP BY MARIO',
        lilahB: 'lilah b.',
        lawless: 'LAWLESS',
        kilianParis: 'KILIAN Paris',
        danessaMyricksBeauty: 'Danessa Myricks Beauty',
        bareMinerals: 'bareMinerals',
        artistCouture: 'Artist Couture',
        westmanAtelier: 'Westman Atelier',
        stila: 'stila',
        roseInc: 'ROSE INC',
        rareBeautyBySelenaGomez: 'Rare Beauty by Selena Gomez',
        perriconeMd: 'Perricone MD',
        kosas: 'Kosas',
        kiehlsSince1851: 'Kiehl’s Since 1851',
        josieMaran: 'Josie Maran',
        itCosmetics: 'IT Cosmetics',
        inCredible: 'INC.redible',
        freckBeauty: 'Freck Beauty',
        fashionFair: 'Fashion Fair',
        esteeLauder: 'Estée Lauder',
        dominiqueCosmetics: 'DOMINIQUE COSMETICS',
        buxom: 'Buxom',
        benefitCosmetics: 'Benefit Cosmetics',
        athrBeauty: 'Athr Beauty'
    };

    return resources[label];
};
